// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// The JSON request every per-domain api module uses (E-05: `api/client.ts` is frozen for new exports,
// so domain modules call the server through this one helper instead of each carrying a copy).

import { apiFetch, parseApiError } from './client'

export async function jsonRequest<T>(method: string, path: string, body?: unknown): Promise<T> {
  // apiFetch prepends API_BASE (/api) itself — pass the bare path.
  const res = await apiFetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) throw await parseApiError(res)
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}
